
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]",
      function () {
        return require("private-next-pages/[country].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[country]"])
      });
    }
  